// extracted by mini-css-extract-plugin
export var searchHeader = "_a1-0";
export var searchHeaderDark = "_a1-1";